import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";

@Injectable()
export class TranslationService {
  private defaultLang = 'ru';
  private _langChanged = new Subject<LangChangeEvent>();
  onLanguageChanged = this._langChanged.asObservable();

  constructor(private translateService: TranslateService,
    private router: Router) {
    translateService.onLangChange.subscribe((s: LangChangeEvent) => {
      this._langChanged.next(s);
    });
  }

  public translate = (message: string): string => {
    if (message) {
      let res = this.translateService.instant(message);
      return res ? res : message;
    }
    return "";
  }

  setLanguageFromUrl = () => {
    const lang = this.getLangFromUrl();

    this.translateService.setDefaultLang(this.defaultLang);
    this.translateService.use(lang);
  }

  changeLanguage = (lang: string) => {
    this.translateService.use(lang);

    const urlSegments = this.router.url.split('/');
    urlSegments[1] = lang;
    this.router.navigate(urlSegments).then(success => console.log(success));
  }

  getLangFromUrl = (): string => {
    let lang = window.location.pathname.split('/')[1];

    if (lang.length > 3) {
      window.location.pathname = `${this.defaultLang}/${lang}`;
    }

    return window.location.pathname.split('/')[1] || this.defaultLang;
  }

  getCurrentLang() {
    return this.translateService.currentLang;
  }
}
